export default {
    topics: [
        {
            title: ' CreateTrackingInstance ',
            href: 'sm-trackingUrl-CreateTrackingInstance.html',
            attributes: { 'data-id': 'sm-trackingUrl-CreateTrackingInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-CreateTrackingInstance-d66e4032',
            topics: [],
        },
        {
            title: ' CreateTrackingInstanceEx ',
            href: 'sm-trackingUrl-CreateTrackingInstanceEx.html',
            attributes: { 'data-id': 'sm-trackingUrl-CreateTrackingInstanceEx' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-CreateTrackingInstanceEx-d66e4040',
            topics: [],
        },
        {
            title: ' CreateTrackingInstanceShell ',
            href: 'sm-trackingUrl-CreateTrackingInstanceShell.html',
            attributes: { 'data-id': 'sm-trackingUrl-CreateTrackingInstanceShell' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-CreateTrackingInstanceShell-d66e4048',
            topics: [],
        },
        {
            title: ' GenerateTag ',
            href: 'sm-trackingUrl-GenerateTag.html',
            attributes: { 'data-id': 'sm-trackingUrl-GenerateTag' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-GenerateTag-d66e4056',
            topics: [],
        },
        {
            title: ' RegisterExternalInstance ',
            href: 'sm-trackingUrl-RegisterExternalInstance.html',
            attributes: { 'data-id': 'sm-trackingUrl-RegisterExternalInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-RegisterExternalInstance-d66e4064',
            topics: [],
        },
        {
            title: ' RegisterTrackingInstance ',
            href: 'sm-trackingUrl-RegisterTrackingInstance.html',
            attributes: { 'data-id': 'sm-trackingUrl-RegisterTrackingInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-trackingUrl-RegisterTrackingInstance-d66e4072',
            topics: [],
        },
    ],
};

